<template lang="pug">
nav.v-internal-nav.internal-nav.internal-nav--pinned(

	:class="{'iternal-nav--open' : openMobileNav}"
)
	v-loader(:loading="loading")
	.internal-nav__overlay()
	.internal-nav__box

	.internal-nav__box-inner(v-if="!loading" )
		.internal-nav__container
			.internal-nav__head
				button.internal-nav__close(v-if="isSm")
					v-svg-icon.internal-nav__close-icon(icon="close" @click="controllerCloseMobileNav")
				//-button.internal-nav__back()
					v-icon.internal-nav__trigger-icon(:icon="'arrow-right'")
				component.internal-nav__logo(v-if="data.logo"
					:href="data?.logo?.src"
					:target="data?.logo?.target"
					:is="data.logo.href ? 'a' : 'div'"
					)
					img.internal-nav__logo-image(
						v-if="data.logo?.src"
						:src="data.logo.src"
						alt="WB SSL")
					.internal-nav__logo-text(v-if="data.logo?.text") {{data.logo.text}}

			.internal-nav__top(v-if="data.topItems && data.topItems.length")
				template(v-for="({text, href, target, active = false}, index) in data.topItems" :key="index" )
					a.internal-nav__top-btn.btn.btn--primary.btn--round.btn--sm-f(:href="href" :target="target" :class="{'internal-nav__top-btn--active': active}") {{text}}
			.internal-nav__group.internal-nav__group--top.flc()
				template(v-for="(item, index) in data.items" :key="index")
					.internal-nav__item.flc
						a.internal-nav__btn(:href="item.link" :class="item.className, {'internal-nav__btn--active': item.active}")
							| {{item.text}}
							template(v-if="item.info")
								.internal-nav__info {{item.info}}
			.internal-nav__group.internal-nav__group--bottom.flc
				template(v-for="({text, className, href, target}, index) in data.bottomItems" :key="index" )
					.internal-nav__item.flc
						button.internal-nav__btn(
								:class="className"
								@click="confirmRemove")
								| {{ text || '' }}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from "../scripts/controller/controller";
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null,
			openMobileNav: false,
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		},

		controllerCloseMobileNav() {
			controller.closeLkMobileMenu();
		},

		mobileNavOpen() {
			this.openMobileNav = true;
		},

		mobileNavClose() {
			this.openMobileNav = false;
		},

		resizeHandler() {
			if(!this.isSm && this.openMobileNav) {
				this.openMobileNav = false;
			}
		},

		removeAccount(action = null) {
			if(!action) return;
			this.dataLoad({
				url: this.data.remote,
				delay: true,
				data: {
					action
				}
			});
		},

		confirmRemove() {
			if(this.data.modalConfirmRemove) {
				controller.openModal({
					component: {
						...this.data.modalConfirmRemove,
						listeners: {
							'confirm': async () => {
								this.removeAccount('remove-account')
							},
						}
					}
				});
			} else {
				this.removeAccount('remove-account')
			}
		},

	},

	created() {
		controller.events.on('lk-nav-open', this.mobileNavOpen);
		controller.events.on('lk-nav-close', this.mobileNavClose);
		window.addEventListener('resize', this.resizeHandler)
	}

}
</script>
